import MUITableView from '@mui/icons-material/TableChart'

export const TableViewIcon = MUITableView
